/* eslint-disable no-magic-numbers */
import Countries from "const/Countries";

export default class Constants {
  static DEFAULT_NUMBERS_LOCALE = "en-US";

  static DEFAULT_LANGUAGE = "en";

  static DEFAULT_CURRENCY = "USD";

  static EMPTY_PLACEHOLDER = "–";

  static NEW_ENTITY_ID = "new";

  static MENTION_TRIGGER_CHAR = "@";

  static COMMENTS = "comments";

  static PARENT_FOLDER_RELATIVE_PATH = "..";

  static DECIMALS_MULTIPLIER = 10;

  static PERCENTS_MULTIPLIER = 100;

  static QUARTER_CIRCLE_DEGREES = 90;

  static HALF_CIRCLE_DEGREES = 180;

  static THREE_QUARTERS_CIRCLE_DEGREES = 270;

  static CIRCLE_DEGREES = 360;

  static DATA_SIMILARITY_COEFFICIENT = 0.8;

  static TABLE_PAGE_SIZE = 20;

  static TABLE_PAGE_SIZE_MEDIUM = 50;

  static TABLE_PAGE_SIZE_MAXIMUM = 100;

  static SEARCH_TEXT_MIN_LENGTH = 3;

  static MAX_API_SEQUENTIAL_ERRORS = 10;

  static REDUX_DEV_TOOLS_TRACE_LIMIT = 30;

  static LAYOUT_MIN_WIDTH = 1010;

  static SIMPLIFIED_LAYOUT_MAX_WIDTH = 1200;

  static DEFAULT_ANIMATION_DURATION = 300;

  static WINDOW_RESIZE_DEBOUNCE_DELAY = 300;

  static TEXT_FIELD_DEBOUNCE_TIMEOUT = 1000;

  static NOTIFICATION_AUTO_CLOSE_DELAY = 5 * 1000;

  static LOGIN_PAGE_REFRESH_TIMEOUT = 60 * 1000;

  static AUTO_LOGOUT_FOR_TEMP_USER = 60 * 1000;

  static AUTO_PAGE_RELOAD_ON_ERROR_DELAY = 60 * 1000;

  static GLOBAL_STATS_UPDATE_INTERVAL = 30 * 1000;

  static DATA_LIST_UPDATE_INTERVAL = 30 * 1000;

  static BUSINESSES_DATA_UPDATE_INTERVAL = 60 * 1000;

  static CONTACTS_DATA_UPDATE_INTERVAL = 5 * 60 * 1000;

  static INSTITUTION_LINKS_EXPIRATION_UPDATE_INTERVAL = 10 * 60 * 1000;

  static MANUAL_RPA_START_COOLDOWN = 3 * 60 * 60 * 1000;

  static LAST_ASKED_EMAIL_EXPIRATION_DURATION = 30 * 24 * 60 * 60 * 1000;

  static MAX_DOCUMENT_PAGES = 50;

  static DEFAULT_DOCUMENT_DUE_DATE_DAYS_OFFSET = 14;

  static ACCOUNT_NUMBER_SUBSTRING_LENGTH = 4;

  static ACCOUNT_EXPIRATION_DAYS_WARNING = 7;

  static GOOGLE_MAPS_SEARCH_URL = "https://google.com/maps/search";

  static QBWC_DEVELOPER_PORTAL_URL = "https://developer.intuit.com";

  static QBWC_INSTALLATION_GUIDE_PATH = "/app/developer/qbdesktop/docs/get-started/get-started-with-quickbooks-web-connector";

  static PHONE_INPUT_PATTERN = /^(\+?\d+)?[\s-]?(\(\d+\)|\d+)[\s-]?\d+[\s-]?\d+[\s-]?\d+$/;

  static SMS_NOTIFICATIONS_ALLOWED_COUNTRIES = [
    Countries.AU,
    Countries.CA,
    Countries.GB,
    Countries.US,
    Countries.ZA
  ];
}
